import { CALIFORNIA_ZIP_CODES_SET } from './constants/californiaZipCodes';

export function exponentialBackoff(attempt, baseDelay = 1000) {
  return baseDelay * Math.pow(2, attempt - 1); // 2^0 = 1, 2^1 = 2, 2^2 = 4,
}

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function isZendeskDecommissioned(){
    try {
        const localData: any = localStorage.getItem('fastFollowFlags')
        return JSON.parse(localData)?.DECOMMISSION_ZENDESK === true
      } catch (e) {
        console.log('fastFollowFlags fail', e)
        return false
      }
}

/**
 * Util method for invoking a callback immediately, after some delay, or/and in regular increments
 * @param callback callback to be invoked
 * @param intervalHandler handler fn to store/clear the interval
 * @param interval the time interval to invoke by. If undefined then no interval is started
 * @param delay the delay for first invocation. Can be 0 for immediate invocation. If undefined then there is no first invocation
 */
export const delayOrInvokeInterval = async (
  callback: () => void,
  intervalHandler: (intervalId: NodeJS.Timeout) => void,
  interval?: number,
  delay?: number
): Promise<void> => {
  if (delay != null) {
    if (delay > 0) {
      await new Promise((resolve, reject) => {
        setTimeout(() => resolve(`Delayed ${delay}ms`), delay)
      })
    }

    callback()
  }

  if (interval != null) {
    const newTimer = setInterval(() => {
      callback()
    }, interval)

    intervalHandler(newTimer)
  }
}

export const getConversationSummaryLanguage = (contextAtt: any) =>{
  const queueLanguages: any = {
    en: 'English',
    de: 'German',
    fr: 'French',
    nl: 'Dutch',
    bg: 'Bulgarian',
    pt_BR: 'Brazilian Portuguese',
    it: 'Italian',
    zh_CN: 'Chinese Simplified',
    cs: 'Czech',
    da: 'Danish',
    et: 'Estonian',
    es: 'Spanish',
    fi: 'Finnish',
    zh_HK: 'Chinese Traditional',
    hu: 'Hungarian',
    he: 'Hebrew',
    ja: 'Japanese',
    ko: 'Korean',
    lt: 'Lithuanian',
    lv: 'Latvian',
    ar: 'Arabic',
    nb: 'Norwegian',
    pl: 'Polish',
    pt_PT: 'Portuguese',
    zh_TW: 'Chinese Traditional',
    ro: 'Romanian',
    ru: 'Russian',
    sv: 'Swedish',
    sl: 'Slovenian',
    sk: 'Slovakian',
    tr: 'Turkish',
    uk: 'Ukrainian',
  }
  const readWithCountryCode = ['pt', 'zh'];
  let language = 'English';
  if (contextAtt?.language && queueLanguages[contextAtt.language]) {
    language = queueLanguages[contextAtt.language];
  } else if (readWithCountryCode.includes(contextAtt?.language)) {
    const formMultipleCombination = [`${contextAtt.language}_${contextAtt.region}`, `${contextAtt.language}_${contextAtt.surfaceRegion}`, `${contextAtt.language}_${contextAtt.surfaceIpRegion}`, `${contextAtt.language}_${contextAtt.country}`];
    formMultipleCombination.forEach((combination) => {
      if (queueLanguages[combination]) {
        language = queueLanguages[combination];
      }
    });
  }
  return language;
}


export const isCustomerFromCalifornia = (postalCode: string) => {
  return CALIFORNIA_ZIP_CODES_SET.has(postalCode)
}